export const version = "abi/5.0.7";
//# sourceMappingURL=_version.js.map